import { Routes } from '@angular/router';

export const COMMERCIAL_ZONES_ROUTES: Routes = [
  {
    path: 'commercial-zones',
    loadComponent: () =>
      import('./commercial-zones-list/commercial-zones-list.component')
        .then(m => m.CommercialZonesListComponent),
  }
];
